import { IconChevron } from 'components/icons/IconChevron'
import { IconInfoDark } from 'components/icons/IconInfoDark'
import { translate } from 'i18n/i18n'
import { useState } from 'react'

export const IrrigationActivityZonesInfoText = ({
  isDurationOrApplied,
}: {
  isDurationOrApplied: boolean
}) => {
  const [collapsed, setCollapsed] = useState(true)

  const statusMessage = translate.phrases.banyanApp(
    'Displays ON when any selected emitter at this location is on, otherwise OFF if any are off, otherwise UNKNOWN',
  )

  const appliedMessage = translate.phrases.banyanApp(
    'Displays total duration or applied volume for all selected emitters at this location',
  )

  const maxLength = 38
  const message = isDurationOrApplied ? appliedMessage : statusMessage
  const displayMessage = collapsed ? message.slice(0, maxLength) + '…' : message

  return (
    <div
      css={{
        color: 'white',
        marginTop: 10,
        width: 270,
        display: 'flex',
        justifyContent: 'space-between',
        gap: 10,
        alignItems: 'start',
      }}
    >
      <div>
        <IconInfoDark />
      </div>
      <div
        css={{
          minHeight: 15,
          flex: 1,
          overflow: 'hidden',
          whiteSpace: collapsed ? 'nowrap' : 'normal',
          textOverflow: collapsed ? 'ellipsis' : 'unset',
          transition: 'all 0.3s ease',
        }}
      >
        <i css={{ fontSize: 12 }}>{displayMessage}</i>
      </div>
      <div
        css={{
          fontSize: 14,
          cursor: 'pointer',
          transform: `rotate(${collapsed ? 0 : 180}deg)`,
          transition: 'transform 0.3s ease',
        }}
        onClick={() => setCollapsed((s) => !s)}
      >
        <IconChevron />
      </div>
    </div>
  )
}
